/**
 * Permission helpers — client-side gate for UI affordances. Backend is the
 * source of truth (all mutations re-validate); these gates only decide
 * whether to render a button or link.
 */

/**
 * Display labels for internal role codes. Internal enum values remain
 * `admin` / `crew_chief` / `engineer` (do not rename — auth + tests depend
 * on them); UI surfaces show the labels below.
 */
export const ROLE_LABELS = {
  admin: "System Admin",
  crew_chief: "User Admin",
  engineer: "User",
};

/** Human-readable label for a role code. Falls back to the raw code when
 * unknown so we never render `undefined` in the UI. */
export function roleLabel(code) {
  return ROLE_LABELS[code] || code || "";
}

/** Admin, Crew Chief, or Manager / Senior Manager job title can change an
 * aircraft's operational status (Normal / Heavy Check / Down for CAPEX).
 */
export function canManageAircraftStatus(user) {
  if (!user) return false;
  if (user.role === "admin" || user.role === "crew_chief") return true;
  return user.job_title === "Manager" || user.job_title === "Senior Manager";
}

/** Leadership tier — admin, crew chief (supervisor), or a Supervisor /
 * Manager / Senior Manager job title. Used to gate the "Team ▾" nav dropdown,
 * the Schedule page, the Shift Log, and other cross-team management surfaces. */
export function isLeader(user) {
  if (!user) return false;
  if (user.role === "admin" || user.role === "crew_chief") return true;
  return user.job_title === "Supervisor" || user.job_title === "Manager" || user.job_title === "Senior Manager";
}
